import React from "react";
import SUDayView from "../SUDayView";

const BehaviourOverviewDay = ({ events, insights }) => {
  return (
    <SUDayView
      currentTab={"Overview"}
      insights={insights}
      events={events}
      noData={false}
      isNewVariant={true}
      isOverview={true}
      isNighttime={false}
      noSplitting={false}
    />
  );
};

export default BehaviourOverviewDay;
